
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/getting-started",
      function () {
        return require("private-next-pages/docs/getting-started.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/getting-started"])
      });
    }
  